import * as tslib_1 from "tslib";
/**
 * @file Fieldset component for repeat input
 * @author Heino Lenting
 */
import { OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { FieldsetBase } from '../../base/fieldsets/fieldset-base/fieldset-base';
import { FieldsetProvider } from '../../base/fieldsets/fieldset-provider';
import { DIRTY_FLAG } from '../../core/breeze.service';
import { LocalisationService } from '../../core/localisation.service';
import { DomainService } from '../../domain.service';
import { RepeatAdapter } from '../helpers/repeat-adapter';
import { ComponentRegistry } from '../../core/component-registry';
/**
 * Class for the repeat fieldset component
 */
var FieldsetRepeatComponent = /** @class */ (function (_super) {
    tslib_1.__extends(FieldsetRepeatComponent, _super);
    /**
     * Constructs a FieldsetRepeatComponent
     * @param translateService Is needed to get a summary of the repeat.
     * @param provider Provides the configuration information for the fieldset.
     */
    function FieldsetRepeatComponent(translateService, localisationService, provider, domainService) {
        var _this = _super.call(this, provider) || this;
        /**
         * Gets, sets the read only mode of the component.
         */
        _this.readOnly = false;
        /** Angular control of this composite is used in the template. */
        _this.factorControl = new FormControl();
        /** Angular control of this composite is used in the template. */
        _this.monthsControl = new FormControl();
        /** Angular control of this composite is used in the template. */
        _this.untilDateControl = new FormControl();
        /** Angular control of this composite is used in the template. */
        _this.endingIsControl = new FormControl();
        /** Angular control of this composite is used in the template. */
        _this.daysControl = new FormControl();
        /** Angular control of this composite is used in the template. */
        _this.offsetTypeControl = new FormControl();
        /** Angular control of this composite is used in the template. */
        _this.orderControl = new FormControl();
        /**
         * Format information for the input select representing
         * the repeat.repeatType property.
         * This is used in the template of the component.
         */
        _this.repeatTypeFormat = [
            { value: 'ONCE', labelKey: 'APP.FORMS.REPEAT.ONCE' },
            { value: 'DAILY', labelKey: 'APP.FORMS.REPEAT.DAILY' },
            { value: 'WEEKDAY', labelKey: 'APP.FORMS.REPEAT.WEEKDAY' },
            { value: 'WEEKLY', labelKey: 'APP.FORMS.REPEAT.WEEKLY' },
            { value: 'MONTHLY', labelKey: 'APP.FORMS.REPEAT.MONTHLY' },
            { value: 'YEARLY', labelKey: 'APP.FORMS.REPEAT.YEARLY' }
        ];
        /**
         * Format information for the input select representing
         * the repeat.repeatType property.
         * This is used in the template of the component.
         */
        _this.orderFormat = [
            { value: 'FIRST', labelKey: 'APP.FORMS.REPEAT.FIRST' },
            { value: 'SECOND', labelKey: 'APP.FORMS.REPEAT.SECOND' },
            { value: 'THIRD', labelKey: 'APP.FORMS.REPEAT.THIRD' },
            { value: 'FOURTH', labelKey: 'APP.FORMS.REPEAT.FOURTH' },
            { value: 'LAST', labelKey: 'APP.FORMS.REPEAT.LAST' }
        ];
        /**
         * Format information for the input checkboxes representing
         * the repeat.days property.
         * This is used in the template of the component.
         */
        _this.daysFormat = [
            { value: 'MON', labelKey: 'APP.FORMS.REPEAT.MON' },
            { value: 'TUE', labelKey: 'APP.FORMS.REPEAT.TUE' },
            { value: 'WED', labelKey: 'APP.FORMS.REPEAT.WED' },
            { value: 'THU', labelKey: 'APP.FORMS.REPEAT.THU' },
            { value: 'FRI', labelKey: 'APP.FORMS.REPEAT.FRI' },
            { value: 'SAT', labelKey: 'APP.FORMS.REPEAT.SAT' },
            { value: 'SUN', labelKey: 'APP.FORMS.REPEAT.SUN' }
        ];
        /**
         * Format information for the input checkboxes representing
         * the repeat.days property.
         * This is used in the template of the component.
         */
        _this.monthsFormat = [
            { value: 1, labelKey: 'APP.FORMS.REPEAT.JANUARY' },
            { value: 2, labelKey: 'APP.FORMS.REPEAT.FEBRUARY' },
            { value: 3, labelKey: 'APP.FORMS.REPEAT.MARCH' },
            { value: 4, labelKey: 'APP.FORMS.REPEAT.APRIL' },
            { value: 5, labelKey: 'APP.FORMS.REPEAT.MAY' },
            { value: 6, labelKey: 'APP.FORMS.REPEAT.JUNE' },
            { value: 7, labelKey: 'APP.FORMS.REPEAT.JULY' },
            { value: 8, labelKey: 'APP.FORMS.REPEAT.AUGUST' },
            { value: 9, labelKey: 'APP.FORMS.REPEAT.SEPTEMER' },
            { value: 10, labelKey: 'APP.FORMS.REPEAT.OCTOBER' },
            { value: 11, labelKey: 'APP.FORMS.REPEAT.NOVEMBER' },
            { value: 12, labelKey: 'APP.FORMS.REPEAT.DECEMBER' }
        ];
        /**
         * Format information for the input checkboxes representing
         * the repeat.days property.
         * This is used in the template of the component.
         */
        _this.dayOfMonthFormat = [
            { value: '1', labelKey: '1' },
            { value: '2', labelKey: '2' },
            { value: '3', labelKey: '3' },
            { value: '4', labelKey: '4' },
            { value: '5', labelKey: '5' },
            { value: '6', labelKey: '6' },
            { value: '7', labelKey: '7' },
            { value: '8', labelKey: '8' },
            { value: '9', labelKey: '9' },
            { value: '10', labelKey: '10' },
            { value: '11', labelKey: '11' },
            { value: '12', labelKey: '12' },
            { value: '13', labelKey: '13' },
            { value: '14', labelKey: '14' },
            { value: '15', labelKey: '15' },
            { value: '16', labelKey: '16' },
            { value: '17', labelKey: '17' },
            { value: '18', labelKey: '18' },
            { value: '19', labelKey: '19' },
            { value: '20', labelKey: '20' },
            { value: '21', labelKey: '21' },
            { value: '22', labelKey: '22' },
            { value: '23', labelKey: '23' },
            { value: '24', labelKey: '24' },
            { value: '25', labelKey: '25' },
            { value: '26', labelKey: '26' },
            { value: '27', labelKey: '27' },
            { value: '28', labelKey: '28' },
            { value: '29', labelKey: '29' },
            { value: '30', labelKey: '30' },
            { value: '31', labelKey: '31' }
        ];
        /**
         * Format information for the input radio buttons representing
         * the repeat.offsetType property.
         * This is used in the template of the component.
         */
        _this.offsetTypeFormat = [
            { value: 'ABSOLUTE', labelKey: 'APP.FORMS.REPEAT.ABSOLUTE' },
            { value: 'RELATIVE', labelKey: 'APP.FORMS.REPEAT.RELATIVE' }
        ];
        var restoringVirtualRepeat = false;
        _this.repeat = new RepeatAdapter(function () {
            var repeat = provider.value;
            if (repeat) {
                if (!repeat.Owner) {
                    var wasModified = repeat.entityAspect.entityState.isModified();
                    repeat.Owner = provider.entity;
                    if (!wasModified) {
                        repeat.entityAspect.setUnchanged();
                    }
                }
                // Fix Issue #1485
                // No should I close window message when repeat was changed of new owner.
                if (provider.entity && repeat.entityAspect.originalValues['Kind']) {
                    // Setting DIRTY_FLAG of owner when repeat Kind has changed.
                    provider.entity[DIRTY_FLAG] = true;
                }
            }
            else if (provider.entity && !restoringVirtualRepeat) {
                // Fix Issue: Bij het opslaan van een aangemaakte Beschikbaarheid wordt niet de regel: Succesvol opgeslagen getoond #2581
                var entity_1 = provider.entity;
                if (entity_1.entityAspect.entityState.isUnchanged() && entity_1['RepeatPattern_Oid'] === null) {
                    restoringVirtualRepeat = true;
                    window.setTimeout(function () {
                        domainService.assignVirtualRepeat(entity_1);
                        entity_1.entityAspect.setUnchanged();
                        restoringVirtualRepeat = false;
                    });
                }
            }
            return repeat;
        }, translateService, localisationService, domainService);
        return _this;
    }
    /**
     * set the value to 1 if user fills in 0
     */
    FieldsetRepeatComponent.prototype.onChange = function () {
        if (this.repeat.factor <= 0) {
            this.repeat.factor = 1;
        }
    };
    /**
     * Register component by the fieldset provider
     */
    FieldsetRepeatComponent.register = function () {
        ComponentRegistry.register('fieldset', 'repeat', FieldsetRepeatComponent);
    };
    /**
     * Is called right after the directive's data-bound properties have been checked for the
     * first time, and before any of its children have been checked.It is invoked only once when the
     * directive is instantiated.
     */
    FieldsetRepeatComponent.prototype.ngOnInit = function () {
        this.readOnly = this.provider.field.readonly ? true : false;
    };
    Object.defineProperty(FieldsetRepeatComponent.prototype, "summary", {
        /**
         * Gets the summary of the current repeat.
         */
        get: function () {
            return this.repeat.summary();
        },
        enumerable: true,
        configurable: true
    });
    return FieldsetRepeatComponent;
}(FieldsetBase));
export { FieldsetRepeatComponent };
